'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _defaults = require('../defaults');

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaults2.default;
  return state;
};
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-config-provider/dist/main/reducers/config.js
// module id = 512
// module chunks = 0